export const CHANGE_CURRENT_PAGE = 'simpleTextSettings/CHANGE_CURRENT_PAGE'
export const CREATE_SIMPLE_TEXT_SETTING = 'simpleTextSettings/CREATE_SIMPLE_TEXT_SETTING'
export const FETCH_SIMPLE_TEXT_SETTINGS_LIST = 'simpleTextSettings/FETCH_SIMPLE_TEXT_SETTINGS_LIST'
export const FETCH_SIMPLE_TEXT_SETTINGS_FOR_OPTIONS = 'simpleTextSettings/FETCH_SIMPLE_TEXT_SETTINGS_FOR_OPTIONS'
export const REMOVE_SIMPLE_TEXT_SETTING = 'simpleTextSettings/REMOVE_SIMPLE_TEXT_SETTING'
export const UPDATE_SIMPLE_TEXT_SETTING = 'simpleTextSettings/UPDATE_SIMPLE_TEXT_SETTING'
